import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UrlBuilderService {

    constructor() { }

    buildUrl(baseUrl: string, queryParams: any): string {
        let url = baseUrl;
        if (queryParams) {
            const params = new URLSearchParams();
            Object.keys(queryParams).forEach(key => {
                params.set(key, queryParams[key]);
            });
            url += '?' + params.toString();
        }
        return url;
    }
}
